import { baseApi } from './baseApi'

export const aiChatApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        // POST /lessor/v1/ai-helpers/cmd AI 助手對話
        sendAiMessage: builder.mutation({
            query: ({ text, is_reset_memory }) => {
                return {
                    url: `lessor/v1/ai-helpers/cmd`,
                    method: 'POST',
                    data: {
                        text,
                        is_reset_memory,
                        // system_prompt: `今天是 2025-06-13,你是一個秘書，請根據我給你的 tool 執行用戶的請求，請注意 tool 的參數名稱與參數有分大小寫，你需要讓用戶感受到你的服務是溫暖的，我的 Tool 執行是即時的，請直接輸出結果，不需要預設延遲。`,
                    },
                }
            },
        }),
    }),
})

export const { useSendAiMessageMutation } = aiChatApi
